export const PICKER_COMPONENT_HEIGHT = 40;